export const pains = ['Te encantaría llegar a casa y desconectar del trabajo.', 'Te gustaría generar ingresos extra sin dejar tu profesión.', 'Buscás reducir el estrés que genera la planificación.', 'Te gustaría disfrutar tus fines de semana sin planificar.', 'Te encantaría dejar de empezar cada planificación desde cero.'];
export const benefits = ["Optimizarás tu tiempo, para que la planificación deje de ser una carga.", 'Aprenderás a transformar tu experiencia docente en una nueva fuente de ingresos.', 'Volverás a sentir que tenés el control de tu tiempo y de tu planificación.', 'Podrás reducir el estrés de planificar y volver a disfrutar de enseñar.', 'Dejarás de improvisar clases y ganarás seguridad en cada jornada.'];
export type Testimonial = {
  name: string;
  location: string;
  /** Dolor de la sección "¿Reconocés alguna de estas historias?" que traía. */
  pain: string;
  /** Beneficio de la sección "Después de 7 días" que consiguió. */
  benefit: string;
  text: string;
  date: string;
};
export const featuredTestimonials: Testimonial[] = [{
  name: 'Lucia S.',
  location: 'Montevideo, Uruguay 🇺🇾',
  pain: 'Planificaba todos los domingos',
  benefit: 'Recuperó sus fines de semana',
  text: 'Perdía todos los domingos armando la semana. Con el Megapack la dejo lista en una hora y el domingo volvió a ser mío.',
  date: '15 de agosto, 2026'
}, {
  name: 'Martina F.',
  location: 'Canelones, Uruguay 🇺🇾',
  pain: 'Empezaba cada planificación desde cero',
  benefit: 'Dejó de improvisar y ganó seguridad',
  text: 'Arrancaba cada unidad desde una hoja en blanco. Ahora abro, elijo y adapto: entro al aula con la clase armada.',
  date: '10 de agosto, 2026'
}, {
  name: 'Carolina G.',
  location: 'Maldonado, Uruguay 🇺🇾',
  pain: 'Quería ingresos extra sin dejar el aula',
  benefit: 'Convirtió su experiencia en ingresos',
  text: 'Con la parte Business empecé a vender cuadernillos adaptados a otras colegas. Sumo ingresos sin dejar mi grado.',
  date: '5 de agosto, 2026'
}, {
  name: 'Javier S.',
  location: 'Salto, Uruguay 🇺🇾',
  pain: 'Llegaba a casa y seguía trabajando',
  benefit: 'Desconecta al terminar la jornada',
  text: 'Salía de la escuela y seguía preparando clases hasta la noche. Hoy cierro la jornada y llego a casa a estar con mis hijos.',
  date: '28 de julio, 2026'
}];
export const moreTestimonials: Testimonial[] = [{
  name: 'Paula R.',
  location: 'Colonia, Uruguay 🇺🇾',
  pain: 'El estrés de planificar',
  benefit: 'Volvió a disfrutar de enseñar',
  text: 'Planificar me generaba angustia cada semana. Con las actividades listas bajé el estrés y volví a disfrutar de dar clase.',
  date: '22 de agosto, 2026'
}, {
  name: 'Tomás A.',
  location: 'Paysandú, Uruguay 🇺🇾',
  pain: 'Sentía que no controlaba su tiempo',
  benefit: 'Optimizó su planificación',
  text: 'Tengo dos cursos y nunca me alcanzaba el tiempo. Ahora planifico el mes entero en una tarde.',
  date: '19 de agosto, 2026'
}, {
  name: 'Verónica M.',
  location: 'Rivera, Uruguay 🇺🇾',
  pain: 'Rehacía todo el material cada año',
  benefit: 'Reutiliza y adapta en minutos',
  text: 'Cada año empezaba de cero. Ahora adapto lo que ya tengo y lo llevo al aula al día siguiente.',
  date: '14 de agosto, 2026'
}, {
  name: 'Daniela P.',
  location: 'Tacuarembó, Uruguay 🇺🇾',
  pain: 'Buscaba ingresos extra',
  benefit: 'Armó su propio negocio educativo',
  text: 'Empecé vendiendo cuadernillos impresos en mi ciudad. En dos meses recuperé la inversión varias veces.',
  date: '8 de agosto, 2026'
}, {
  name: 'Federico L.',
  location: 'Durazno, Uruguay 🇺🇾',
  pain: 'Improvisaba clases sobre la marcha',
  benefit: 'Gana seguridad en cada jornada',
  text: 'Entraba al aula resolviendo sobre la marcha. Hoy llego con todo preparado y los chicos lo notan.',
  date: '3 de agosto, 2026'
}, {
  name: 'Sofía B.',
  location: 'Rocha, Uruguay 🇺🇾',
  pain: 'No lograba desconectar del trabajo',
  benefit: 'Disfruta sus fines de semana',
  text: 'Vivía con la mochila mental de la escuela. Ahora corto al salir y el fin de semana es mío.',
  date: '30 de julio, 2026'
}];
export const faqs = [{
  question: '¿Es para mí si quiero emprender pero nunca lo hice?',
  answer: 'Sí. El MegaPack incluye la guía completa de monetización paso a paso. No necesitás saber de negocios. Necesitás seguir el sistema.'
}, {
  question: '¿Está realmente alineado al EBI? ¿O es material genérico con otra etiqueta?',
  answer: 'Cada tomo fue desarrollado específicamente para el Programa EBI de ANEP Uruguay 2026, con las competencias, los tramos, las metas y las progresiones del programa oficial. No es material argentino ni español adaptado: es material uruguayo para docentes uruguayos.'
}, {
  question: '¿En qué formato viene y desde dónde puedo usarlo?',
  answer: 'Son archivos PDF listos para usar. Los abrís desde el celular, la tablet o la computadora, los proyectás en clase o los imprimís las veces que quieras. No necesitás programas especiales ni saber diseño.'
}, {
  question: '¿Cómo recibo el material después de pagar?',
  answer: 'Inmediatamente después de confirmar el pago por Mercado Pago, recibís un correo electrónico con el link de descarga de todos los PDFs. Sin esperas. Sin envíos. Sin trámites.'
}, {
  question: '¿Es editable?',
  answer: 'Los PDFs están listos para usar directamente: están diseñados para imprimir, proyectar o aplicar sin necesidad de editar nada. Eso es justamente lo que te ahorra tiempo. De todos modos, con herramientas de edición podés adaptarlo a tu necesidad.'
}];
export const PRICE = {
  original: '$4990',
  current: '$1990',
  discount: '50% OFF',
  currency: 'UYU'
};
export const DOWNLOADS = '1,247';
export const SAMPLE_URL = 'https://drive.google.com/file/d/1-Bmm00mboYlPa577IGqC73UKg7g1orqM/view?usp=sharing';
export const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/o3UKasgYc6WoYnXHrtWNiR/ChatGPT_Image_23_jul_2026,_09_10_47_p.m..png';
export const MOCKUP_ALT = 'Megapack Aula de Éxitos Business: recursos digitales para primaria con más de 1600 actividades';